import React, { lazy, Suspense } from 'react';

const YBUG_ID = import.meta.env.VITE_YBUG_ID;

// Lazy load YbugProvider only when needed to avoid React hooks conflicts
const LazyYbugProvider = YBUG_ID 
  ? lazy(() => import('ybug-react').then(mod => ({ default: mod.YbugProvider })))
  : null;

export const YbugProvider = ({ children }: { children: React.ReactNode }) => {
  if (!YBUG_ID || !LazyYbugProvider) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<>{children}</>}>
      <LazyYbugProvider ybugId={YBUG_ID}>{children}</LazyYbugProvider>
    </Suspense>
  );
};
